import React, { Component } from 'react';
import { Button, Modal, Table, Input, Select, InputNumber, Popover, Radio, Popconfirm, message, Dropdown, Menu, Upload, Tooltip, Checkbox } from 'antd';
import { DeleteOutlined, PlusOutlined, EyeOutlined, PlusSquareOutlined } from '@ant-design/icons';
import _ from 'lodash';
import Pic from '../../../resource/img/404pic.jpg';
import styles from './index.module.css';
import { getOssBaseAuth, getDepartment_Data } from '../../../config/storage.js';
import { getOrder2, putBackOrder } from '../../../services/orderCore.js';
import { putDealdata } from '../../../services/measureData.js';
import { getVideoInfo, getVideoPlay, getVideoSub, } from '../../../services/newOder.js';
import convert from '../../../utils/convert.js';
import { getInstall, singlePulley, singlePulley1, rodrailsTypes, standardsTypes, sizeWidth2, sizeHeight2, } from '../../../utils/remark.js';
import { ossUpload, } from '../../../utils/ossUpload.js';
import RemarksModal from './remarksModal2.jsx';
import RelateModal from './relateModal2.jsx';
import MasterModal from '../masterModal.jsx';
import SizeModal from '../sizeModal.jsx';
import SpecialModal from '../specialModal.jsx';

const roomType = ['客厅', '主卧', '主卧飘窗内', '主卧飘窗外', '次卧', '次卧飘窗内', '次卧飘窗外', '阳台', '儿童房', '卫生间', '厨房', '书房', '餐厅', '榻榻米房', '客卧'];
const productType = ['罗马杆', '直轨', '弯轨', '成品帘'];
const { Option } = Select;
const init = {
  id: 0,
  order: 0,
  room: '',
  width: '0',
  width_remark: '满盒尺寸',
  height: '0',
  height_remark: '盒顶到地面',
  prop1: '直轨',//产品类型
  prop2: '顶装',//安装方式
  prop3: '无',//窗帘盒
  prop4: '||',//窗帘盒尺寸  //单层滑轮数|是否含滑臂
  prop5: '单层',//层数 //成品帘拉绳//d
  prop6: '双开|平分双开|',//开合方式  双开|平分双开|备注
  prop7: '普通窗|否|',//窗户类型|是否内开窗|内开窗距离
  prop8: '',
  prop9: '混凝土',//安装墙面
  prop10: '否',//是否超高
  prop11: '否',//是否拆旧
  prop12: '/',//安装面宽度
  prop13: '',//罗马杆装饰头
  prop14: '无',//石膏线
  prop15: '/',//石膏线尺寸  //（已安装）活动走珠间隙
  prop16: '无|/|',//有无窗幔|尺寸|包边情况
  prop17: '手动|无||否',//驱动方式|有无电源|电源方向|玻璃满墙
  prop18: '',
  prop19: '',//离地尺寸
  prop20: '否|',//是否需要做飘窗垫|飘窗垫厚度
  prop21: '',//窗台是否凸出|尺寸   //有无把手凸出|尺寸  //是否需要截断发货
  pic: [],
  vod: [],
  state: '',
  remark: '',
  plasterLine: '无',
}
const newData = {
  id: 0,
  order: 0,
  room: '主卧',
  width: '0',
  width_remark: '满墙',
  height: '0',
  height_remark: '石膏线下到地面',
  prop1: '罗马杆',
  prop2: '侧装',
  prop3: '无',
  prop4: '',
  prop5: '单层',//***
  prop6: '单开|布往右边收|',
  prop7: '普通窗户|无',//** 
  prop8: '',
  prop9: '混凝土',//** 
  prop10: '否',//*
  prop11: '否',//*
  prop12: '/',
  prop13: '两边装饰头',//*
  prop14: '无',
  prop15: '/',
  prop16: '/',
  prop17: '无电源',
  prop18: '',
  prop19: '',
  prop20: '',//*
  prop21: '',//*
  pic: [],
  vod: [],
  state: '',
  remark: '无',
  plasterLine: '无',
}


class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      visibleRoom: false,
      id: 0,
      orderInfo: {},
      confirmLoading: false,
      dataSource: [],
      workInfo: {},
      modalIndex: 0,
      modalValue: '',
      firstLine: '石膏线',
      firstChoose: ['有', '无'],
      widthExplain: [],
      heightExplain: [],
      modalTitle: '房间名称',
      prop3Title: '窗帘盒',
      workRemark: '',
      allPics: [],
      allVideos: [
        // {
        //   id: '0012a462ac6871ee80055017f1f80102',
        //   url: 'https://vod.lijuyun.cn/sv/222af43f-18cddc14e90/222af43f-18cddc14e90.mp4'
        // }
      ],
    }
    // this.baseUrl = getDepartment_Data().resource;
    // this.baseUrl = getDepartment_Data().temp;
    this.baseUrl = getDepartment_Data().service;
    this.remarksModal = React.createRef();
    this.relateModal = React.createRef();
    this.masterModal = React.createRef();
    this.sizeModal = React.createRef();
    this.specialModal = React.createRef();
  }
  // 799098
  render() {
    const { orderInfo, visible, confirmLoading, dataSource, workInfo, visibleRoom, modalValue, modalTitle,
      widthExplain, heightExplain, prop3Title, workRemark, allPics, allVideos } = this.state;
    let columns = [
      {
        title: '操作',
        align: 'center',
        width: 70,
        key: 'operate',
        className: 'solid3',
        render: (text, record, index) => {
          return (
            <div>
              <Tooltip title="删除">
                <Popconfirm
                  title="你确定要删除此条数据吗?"
                  onConfirm={this.onConfirm.bind(this, index)}
                  okText="删除"
                  cancelText="返回"
                >
                  <DeleteOutlined className={`${styles['icon_style']} margin-r5`} />
                </Popconfirm >
              </Tooltip>
              <Tooltip title="向上插入">
                <PlusSquareOutlined className={`${styles['icon_style']} ${styles['icon_style1']} margin-r5`}
                  onClick={this.onInsert.bind(this, index)} />
              </Tooltip>
            </div>
          )
        }
      },
      {
        title: '房间',
        align: 'center',
        width: 80,
        key: 'room',
        className: 'padding0 solid3',
        render: (text, record, index) => {
          return (
            <div className='row'>
              <div className={`${styles['room_div_style']} twoline w100`}
                onClick={this.getModal.bind(this, index, record.room, '房间名称')}>{record.room} </div>
            </div>
          )
        }
      },
      {
        title: '特殊备注',
        align: 'center',
        width: 120,
        key: 'remark',
        className: 'padding0 h100 solid3',
        render: (text, record, index) => {
          return (
            <div className='h100 w100' onClick={this.showSpecial.bind(this, record, index)}>
              <div className={`${styles['remark']} padding0 h90 lh15 scroll-y`}
              >{record.remark} </div>
            </div>
          )
        }
      },
      {
        title: '建议产品',
        align: 'center',
        width: 88,
        key: 'product',
        className: 'padding0 solid3',
        render: (text, record, index) => {
          return (
            <div className='col'>
              <div className={`${styles['room_div_style']} w100 oneline`} onClick={this.onOpenRelate.bind(this, record, index)}>
                {record.prop17.split('|')[0] === '电动' ? '电动' : ''}{record.prop1}
              </div>
              {/* <div className='margin-t5 color2'>{record.prop17.split('|')[0]}</div> */}
            </div>
          )
        }
      },
      {
        title: '安装方式',
        align: 'center',
        width: 110,
        key: 'install',
        className: 'padding0 solid3',
        render: (text, record, index) => {
          let list = getInstall(record.prop1)
          let currentProp2 = '';
          let holder = '';
          if ((record.prop1 + record.prop2).includes('罗马杆侧装') || (record.prop1 + record.prop2).includes('宜家罗马杆侧装')) {
            let prop2res = record.prop2.split('|');
            currentProp2 = prop2res[0];
            holder = prop2res[1] ? prop2res[1] : '';
          } else {
            currentProp2 = record.prop2;
          }
          return (
            <div className='col-t'>
              <Select value={currentProp2} onChange={this.onSelectType.bind(this, index)} className='w100'>
                {
                  list.map((item, index) => {
                    return <Option value={item} key={index}>{item}</Option>
                  })
                }
              </Select>
              {
                holder === '是' ?
                  <div className='margin-t5 color2'>旋转支架：{holder}</div>
                  : <div className=''> </div>
              }
            </div>
          )
        }
      },
      {
        title: '宽度尺寸',
        align: 'center',
        width: 75,
        key: 'width',
        className: 'solid3',
        render: (text, record, index) => {
          return (
            <Input.TextArea value={record.width}
              onChange={this.changeSum.bind(this, index, 'width')} className='padding0 h90 lh15' />
          )
        }
      },
      {
        title: '宽度说明',
        align: 'center',
        width: 100,
        key: 'width_content',
        className: 'padding5 solid3',
        render: (text, record, index) => {
          return (
            <div className='row'>
              <Popover content={record.width_remark} title='宽度说明'>
                <div
                  className={`${styles['room_instr']}`}
                  onClick={this.getModal.bind(this, index, record.width_remark, '宽度说明')}
                >
                  {record.width_remark}
                </div>
              </Popover>
            </div>
          )
        }
      },
      {
        title: '高度尺寸',
        align: 'center',
        width: 75,
        key: 'height',
        className: 'solid3',
        render: (text, record, index) => {
          return (
            <Input.TextArea value={record.height} onChange={this.changeSum.bind(this, index, 'height')} className='padding0 h90 lh15' />
          )
        }
      },
      {
        title: '高度说明',
        align: 'center',
        width: 100,
        key: 'height_content',
        className: 'padding5 solid3',
        render: (text, record, index) => {
          return (
            <div className='row'>
              <Popover content={record.height_remark} title='高度说明'>
                <div className={`${styles['room_instr']}`} onClick={this.getModal.bind(this, index, record.height_remark, '高度说明')}>{record.height_remark}</div>
              </Popover>
            </div>
          )
        }
      },
      {
        title: '窗帘盒(宽*高)',
        align: 'center',
        width: 95,
        key: 'box_size',
        className: 'padding5 solid3',
        render: (text, record, index) => {
          return (
            <div className='col'>
              <Radio.Group onChange={this.changeSum.bind(this, index, 'prop3')} value={record.prop3} className=''>
                <Radio value={'有'}>有</Radio>
                <Radio value={'无'}>无</Radio>
              </Radio.Group>
              {
                record.prop3 === '有' &&
                <Input value={record.prop4.split('|')[0]} onChange={this.changeSum.bind(this, index, 'prop4')}
                  placeholder='请输入宽高尺寸' className='margin-t10' />
              }
            </div>
          )
        }
      },
      {
        title: '房顶/石膏线到窗户上沿距离',
        align: 'center',
        width: 100,
        key: 'stone_locate',
        className: 'padding0 solid3',
        render: (text, record, index) => {
          return (
            <div>
              {
                record.prop1 === '磁控百叶' ?
                  <div>/</div>
                  :
                  <div className='col'>
                    <Radio.Group onChange={this.changeSum.bind(this, index, 'prop14')} value={record.prop14}>
                      <Radio value={'有'}>有石膏线</Radio>
                      <Radio value={'无'}>无石膏线</Radio>
                    </Radio.Group>
                    {
                      // record.prop2 !== '已安装' &&
                      <Input value={record.prop15} onChange={this.changeSum.bind(this, index, 'prop15')}
                        placeholder='请输入距离' className='margin-t10' />
                    }
                  </div>
              }
            </div>
          )
        }
      },
      {
        title: '窗框深度/框顶安装面',
        align: 'center',
        width: 90,
        key: 'window',
        className: 'solid3',
        render: (text, record, index) => {
          return (
            <Input value={record.prop12} onChange={this.changeSum.bind(this, index, 'prop12')} />
          )
        },
      },
      {
        title: '电源方向',
        align: 'center',
        width: 100,
        key: 'window',
        className: 'padding0 solid3',
        render: (text, record, index) => {
          return (
            <div className='col-t vertical-lt'>
              {
                record.prop17.split('|')[0] === '电动' ?
                  <div className='col'>
                    <Radio.Group value={record.prop17.split('|')[1]} onChange={this.changeSum.bind(this, index, 'power')} className=''>
                      <Radio value={'有'}>有电源</Radio>
                      <Radio value={'无'}>无电源</Radio>
                    </Radio.Group>
                  </div>
                  : <div className='w100 tc'>/</div>
              }
              {
                record.prop17.split('|')[0] === '电动' && record.prop17.split('|')[1] === '有' &&
                <div className='col margin-t10'>
                  <Radio.Group value={record.prop17.split('|')[2]} onChange={this.changeSum.bind(this, index, 'powerDir')} className=''>
                    <Radio value={'左侧'}>左侧电源</Radio>
                    <Radio value={'右侧'}>右侧电源</Radio>
                    <Radio value={'左右'}>左右电源</Radio>
                  </Radio.Group>
                </div>
              }
            </div>
          )
        },
      },
      {
        title: '窗幔尺寸',
        align: 'center',
        width: 106,
        key: 'window',
        className: 'padding0 solid3',
        render: (text, record, index) => {
          let result = false;
          if (singlePulley1.includes(record.prop1)) {
            result = true;
          }
          return (<div>{
            result ?
              <div className='col'>
                <Radio.Group onChange={this.changeSum.bind(this, index, 'valance')} value={record.prop16.split('|')[0]} className=''>
                  <Radio value={'有'}>有</Radio>
                  <Radio value={'无'}>无</Radio>
                </Radio.Group>
                <Input value={record.prop16.split('|')[1]} onChange={this.changeSum.bind(this, index, 'valanceSize')}
                  placeholder='请输入尺寸' className='margin-t10' />
                <div className='margin-t5'>{record.prop16.split('|')[2]}</div>
              </div>
              :
              <div>/</div>
          }
          </div>
          )
        },
      },
      {
        title: '常用备注1',
        align: 'center',
        width: 134,
        key: 'remark2',
        className: 'padding0 solid3',
        render: (text, record, index) => {
          return (
            <div className={styles['remarks']} onClick={this.onRemarksModal.bind(this, index, record)}>
              {
                !(standardsTypes.concat(['磁控百叶'])).includes(record.prop1) &&
                <div className='row-l'>
                  <div className='tl'>层数:</div>
                  <div className={record.prop5 === '单层' ? '' : 'color2'}>{record.prop5}</div>
                </div>
              }
              {
                !(standardsTypes.concat(['磁控百叶'])).includes(record.prop1) &&
                <div className='row-l vertical-lt'>
                  <div className='w60'>开合方式:</div>
                  <div className='w80'>
                    {['多开', '大小片', '备注'].includes(record.prop6.split('|')[1]) ?
                      record.prop6 : record.prop6.slice(0, -1)}
                  </div>
                </div>
              }
              <div className='row-l vertical-lt'>
                <div className=''>窗户类型:</div>
                <div className={record.prop7.split('|')[0] === '普通窗' ? '' : 'color2'}>{record.prop7.split('|')[0]}</div>
              </div>
              {
                record.prop1 !== '磁控百叶' &&
                <div className='row-l vertical-lt'>
                  <div className='tl'>内开窗:</div>
                  <div className={record.prop7.split('|')[1] === '是' ? 'color2' : ''}>
                    {record.prop7.split('|')[1]}
                    {
                      record.prop7.split('|')[1] === '是' ?
                        `|${record.prop7.split('|')[2]}厘米`
                        : ''
                    }
                  </div>
                </div>
              }
              {
                ['罗马杆', '宜家罗马杆', '梦幻帘'].concat(rodrailsTypes).includes(record.prop1) &&
                <div className='row-l'>
                  <div>离地/离台尺寸:</div>
                  <div>{(record.prop19 || record.prop19 === '0') && record.prop19 !== '无' ? '离地 ' + record.prop19 + ' 厘米' : '无'}</div>
                </div>
              }
              {
                standardsTypes.includes(record.prop1) &&
                <div className='row-l'>
                  <div>拉绳:</div>
                  <div>{record.prop5}</div>
                </div>
              }
              {
                record.prop1 === '磁控百叶' &&
                <div>
                  <div className='row-l'>
                    <div className=' tr'>c :</div>
                    <div className=''>{record.prop20}厘米</div>
                    <div className=' tr'>d :</div>
                    <div>{record.prop5}厘米</div>
                  </div>
                  <div className='row-l'>
                    <div className=''>e上:</div>
                    <div className=''>{record.prop16}厘米</div>
                    <div className=''>e下:</div>
                    <div>{record.prop21}厘米</div>
                  </div>
                  <div className='row-l'>
                    <div className=''>e左:</div>
                    <div className=''>{record.prop13}厘米</div>
                    <div className=''>e右:</div>
                    <div >{record.prop19}厘米</div>
                  </div>
                </div>
              }
            </div >
          )
        }
      },
      {
        title: '常用备注2',
        align: 'center',
        width: 140,
        key: 'remark3',
        className: 'padding0 padding-l5 solid3',
        render: (text, record, index) => {
          return (
            <div className={styles['remarks']} onClick={this.onRemarksModal.bind(this, index, record)}>
              <div className='row-l'>
                <div>墙面材质:</div>
                <div className={record.prop9 === '混凝土' ? '' : 'color2'}>{record.prop9}</div>
              </div>
              {
                record.prop17.split('|')[0] === '电动' &&
                ['无类型(幔)已安装', '无类型(熨烫)已安装', '宜家轨道已安装', '窗帘盒挡板已安装', '连体轨道已安装',].includes(record.prop1 + record.prop2) &&
                <div className='row-l'>
                  <div>玻璃满墙:</div>
                  <div className={record.prop17.split('|')[3] === '是' ? 'color2' : ''}>
                    {record.prop17.split('|')[3]}
                  </div>
                </div>
              }
              {
                !['罗马杆', '宜家罗马杆', '磁控百叶'].includes(record.prop1) &&
                <div className='row-l'>
                  <div>是否做飘窗垫:</div>
                  <div className={record.prop20 && record.prop20.split('|')[0] === '是' ? 'color2' : ''}>
                    {record.prop20 ? record.prop20.split('|')[0] : ''}
                    {
                      record.prop20 && record.prop20.split('|')[0] === '是' ?
                        `|${record.prop20.split('|')[1]}厘米`
                        : ''
                    }
                  </div>
                </div>
              }
              {
                ['罗马杆', '宜家罗马杆',].includes(record.prop1) && record.prop2 !== '已安装' &&
                <div>
                  {/* <div className='row-l'>
                    <div>是否裁断发货:</div>
                    <div className={record.prop21 === '是' ? 'color2' : ''}>
                      {record.prop21}
                    </div>
                  </div> */}
                  <div className='row-l'>
                    <div>装饰头:</div>
                    <div className={record.prop13 === '两边装饰头' ? '' : 'color2'}>
                      {record.prop13}
                    </div>
                  </div>
                </div>
              }
              {
                standardsTypes.includes(record.prop1) && record.prop2 !== '已安装' &&
                <div className='row-l'>
                  <div>有无把手凸出:</div>
                  <div className={record.prop21 && record.prop21.split('|')[0] === '有' ? 'color2' : ''}>
                    {record.prop21 ? record.prop21.split('|')[0] : ''}
                  </div>
                  {
                    record.prop21 && record.prop21.split('|')[0] === '有' &&
                    <div className={record.prop21.split('|')[0] === '有' ? 'color2' : ''}>
                      |{record.prop21.split('|')[1]}厘米
                    </div>
                  }
                </div>
              }
              {
                record.prop1 === '梦幻帘' && record.prop2 !== '已安装' &&
                <div className='row-l'>
                  <div>窗台石是否凸出:</div>
                  <div className='row-l'>
                    <div className={record.prop21.split('|')[0] === '是' ? 'color2' : ''}>
                      {record.prop21.split('|')[0]}
                    </div>
                    {
                      record.prop21.split('|')[0] === '是' &&
                      <div className={record.prop21.split('|')[0] === '是' ? 'color2' : ''}>
                        |{record.prop21.split('|')[1]}厘米
                      </div>
                    }

                  </div>
                </div>
              }
              {
                ['蛇形帘'].includes(record.prop1) && record.prop2 === '已安装' &&
                <div className='row-l'>
                  <div>活动走珠间隙:</div>
                  <div>{record.prop13}厘米</div>
                </div>
              }
              {
                (singlePulley.includes(record.prop1) || ['罗马杆', '宜家罗马杆',].includes(record.prop1)) && record.prop2 === '已安装' &&
                <div className='col-t vertical-lt'>
                  <div className='row-l'>
                    {
                      (singlePulley.includes(record.prop1)) &&
                      <div>单层走珠数量：{record.prop4.split('|')[1]}个</div>
                    }
                    {
                      ['罗马杆', '宜家罗马杆',].includes(record.prop1) && record.prop4.split('|')[2] !== '无吊环' &&
                      <div>单层吊环数量：{record.prop4.split('|')[1]}个</div>
                    }
                  </div>
                  {
                    (singlePulley1.includes(record.prop1) || ['罗马杆', '宜家罗马杆',].includes(record.prop1)) &&
                    <div className='row-l'>
                      {
                        singlePulley1.includes(record.prop1) &&
                        <div className='mw120 '>是否含{record.prop17.split('|')[0] === '电动' ? '固定环和滑车臂环' : '两头固定环'}:</div>
                      }
                      {
                        ['罗马杆', '宜家罗马杆',].includes(record.prop1) &&
                        <div>吊环:</div>
                      }
                      <div>{record.prop4.split('|')[2]}</div>
                    </div>
                  }

                </div>
              }
              <div className='row-l'>
                <div>是否超高:</div>
                <div className={record.prop10 === '是' ? 'color2' : ''}>{record.prop10}</div>
              </div>
              <div className='row-l'>
                <div>是否拆旧:</div>
                <div className={record.prop11 === '是' ? 'color2' : ''}>{record.prop11}</div>
              </div>

            </div>
          )
        }
      },
      {
        title: '成品尺寸',
        align: 'center',
        width: 140,
        key: 'remark3',
        className: 'padding0',
        render: (text, record, index) => {
          if (record.prop18 || record.prop8) {
            return (
              <div className={`col-t vertical-lt ${styles['remarks']} tl`} onClick={this.changeSize.bind(this, index, record)}>
                {
                  record.prop18 &&
                  <div>尺寸:{record.prop18}（米）</div>
                }
                <div>说明:{record.prop8}</div>
              </div>
            );
          } else {
            return (
              <div className={`${styles['remarks']} padding-tb5`} onClick={this.changeSize.bind(this, index, record)}>&nbsp;暂不提供&nbsp;</div>
            );
          }
        }
      }
    ];
    return (
      <Modal
        title={this.getTitle(workInfo, orderInfo)}
        // `数据整理   （客户：${workInfo.customer},客户电话：${workInfo.customerTel}）（师傅：${workInfo.name}，联系电话：${workInfo.phone}）`
        visible={visible}
        onCancel={this.decide}
        width={2000}
        bodyStyle={{ height: 780 }}
        style={{ top: 0 }}
        confirmLoading={confirmLoading}
        footer={
          <div>
            <Button onClick={this.backOrder} type='danger' className=''>驳回</Button>
            <Button onClick={this.decide} key='cancel' loading={confirmLoading}>取消</Button>
            <Button onClick={this.onOkData.bind(this, '暂存')} type='dashed' key='save' loading={confirmLoading}>暂存</Button>
            {/* <Button onClick={this.onOkData.bind(this, '同步')} type='primary' key='synchronous' loading={confirmLoading}>确定并同步投诉</Button> */}
            <Button onClick={this.onOkData.bind(this, '确定')} type='primary' key='sure' loading={confirmLoading}>确定</Button>
          </div>
        }
      >
        <Table
          columns={columns}
          dataSource={dataSource}
          size={'small'}
          rowKey={record => record.id}
          bordered
          pagination={false}
          scroll={{ y: 340, x: 1740 }}
          style={{
            borderTop: '1px solid #ccc',
            borderLeft: '1px solid #ccc',
            borderRight: '1px solid #ccc',
            borderSpacing: '0'
          }}
        />
        <div className='row-sb margin-t10 w100'>
          <div className='row-l'>
            <div className='w126 tc'>师傅备注：</div>
            < Input value={workRemark} onChange={this.onRemarkChange} className='w850' />
          </div>
          <Button type='primary' className='margin-r10' onClick={this.onAddClick}>新增</Button>
        </div>
        <div className='row-sb margin-t10 vertical-lt w100'>
          <div className='row-l vertical-lt'>
            <div className='col'>
              <Upload
                type='file'
                beforeUpload={this.upLoad}
                customRequest={() => {
                }}
                fileList={[]}
                accept='.jpg,.png,.jpeg,.icon,.svg,.gif'
                // accept='image/*'
                multiple={true}
              // onChange={this.onAddPic.bind(this,)}
              >
                <div className={`row cursor-pointer ${styles['pic-div']} h50`}>
                  <div className="row h100">
                    <PlusOutlined />
                    <span>
                      新增图片
                    </span>
                  </div>
                </div>
              </Upload>
              <Upload
                type='file'
                beforeUpload={this.uploadVideo}
                customRequest={() => { }}
                fileList={[]}
                multiple={false}
                maxCount={1}
              >
                <div className={`row cursor-pointer ${styles['pic-div']} h50`}>
                  <div className="row h100">
                    <PlusOutlined />
                    <span>
                      新增视频
                    </span>
                  </div>
                </div>
              </Upload>
            </div>
            <div className='col-t vettical-lt w100'>
              <div className='row-w w100'>
                {
                  allPics.map((item, index) => {
                    return (
                      <div key={index} className={`${styles['content']}`}>
                        <Dropdown
                          overlay={
                            <Menu>
                              {
                                dataSource.map((ditem, dindex) => {
                                  return (
                                    <Menu.Item onClick={this.onSwitchPicAll.bind(this, index)} key={dindex}>{ditem.room}</Menu.Item>
                                  );
                                })
                              }
                            </Menu>
                          }
                        >
                          <div className={`row ${styles['pic-icon']}`}>
                            全部图片
                            <Popconfirm
                              title="你确定要删除这张图片吗?"
                              onConfirm={this.deletePicAll.bind(this, index)}
                              okText="删除"
                              cancelText="取消"
                            >
                              <DeleteOutlined className='margin-l5' />
                            </Popconfirm>
                          </div>
                        </Dropdown>
                        <img
                          alt="暂无图片"
                          className={`${styles['pic']}`}
                          src={`${this.baseUrl}/upload/${item}`}
                        />
                        <div className={`row ${styles['content-div']}`}>
                          <EyeOutlined
                            className={`${styles['pic-icon-E']}`}
                            onClick={this.preview.bind(this, `${this.baseUrl}/upload/${item}`)}
                            theme="outlined"
                            title="预览"
                          />
                        </div>
                      </div>
                    );
                  })
                }
              </div>
              <div className='row-w margin-t10 w100'>
                {
                  allVideos.map((item, index) => {
                    return (
                      <div className={`${styles['video-box']} col-t vertical-lt`} key={index}>
                        <div className={`${styles['content-video']}`}>
                          <video controls='controls' className={styles['content-image']}
                            // src={"https://vod.lijuyun.cn/sv/447ef52a-18cdd736632/447ef52a-18cdd736632.mp4"}
                            src={item}
                          />
                        </div>
                        <div className='row'>
                          <Dropdown
                            overlay={
                              <Menu className={styles['select-over']}>
                                <Menu.Item onClick={this.onSwitchVideoAll.bind(this, index)} key={dataSource.length}>全部视频</Menu.Item>
                                {
                                  dataSource.map((ditem, dindex) => {
                                    return (
                                      <Menu.Item onClick={this.onSwitchVideoAll.bind(this, index)} key={dindex}>{ditem.room}</Menu.Item>
                                    );
                                  })
                                }
                              </Menu>
                            }
                          >
                            <Button type='primary' className='w90 margin-t5'>切换</Button>
                          </Dropdown>
                          <Popconfirm
                            title="您确定要删除该视频吗?"
                            onConfirm={this.delVideoAll.bind(this, index)}
                            okText="确认"
                            cancelText="取消"
                          >
                            <Button type='danger' className='w90 margin-t5'>删除视频</Button>
                          </Popconfirm>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </div>
          {
            dataSource.length === 0 &&
            <Button type='primary' className='margin-r10 margin-t10' onClick={this.onMeasure}>一键整理</Button>
          }
        </div>
        <div className={`${styles['box_style']} row-w vertical-lt margin-t10 bord1`}>
          {
            dataSource.map((item, index) => {
              return (
                <div className={`${styles['pic_box']} col-t vertical-lt margin-r20`} key={index}>
                  <div>{item.room}:</div>
                  <div className='row-sb vertical-lt w100'>
                    <div className='row-w w400'>
                      {
                        item.pic.map((pitem, pindex) => {
                          return (
                            <div key={pindex} className={`${styles['content']}`}>
                              <Dropdown
                                overlay={
                                  <Menu className={styles['select-over']}>
                                    <Menu.Item onClick={this.onSwitchPic.bind(this, pindex, index)} key={dataSource.length}>全部图片</Menu.Item>
                                    {
                                      dataSource.map((ditem, dindex) => {
                                        return (
                                          <Menu.Item onClick={this.onSwitchPic.bind(this, pindex, index)} key={dindex}>{ditem.room}</Menu.Item>
                                        );
                                      })
                                    }
                                  </Menu>
                                }
                              >
                                <div className={`row ${styles['pic-icon']}`}>
                                  {item.room}
                                  <Popconfirm
                                    title="你确定要删除这张图片吗?"
                                    onConfirm={this.deletePic.bind(this, pindex, index)}
                                    okText="删除"
                                    cancelText="取消"
                                  >
                                    <DeleteOutlined className='margin-l5' />
                                  </Popconfirm>
                                </div>
                              </Dropdown>
                              <img
                                draggable="false"
                                alt="暂无图片"
                                className={`${styles['pic']}`}
                                src={`${this.baseUrl}/upload/${pitem}`}
                              />
                              <div className={`row ${styles['content-div']}`}>
                                <EyeOutlined
                                  className={`${styles['pic-icon-E']}`}
                                  onClick={this.preview.bind(this, `${this.baseUrl}/upload/${pitem}`)}
                                  theme="outlined"
                                  title="预览"
                                />
                              </div>
                            </div>
                          );
                        })
                      }
                    </div>
                    <div>
                      {
                        item.vod.map((vitem, vindex) => {
                          return (
                            <div className={`${styles['video-box']} col-t vertical-lt`} key={vindex}>
                              <div className={`${styles['content-video']}`}>
                                <video controls='controls' className={styles['content-image']}
                                  // src={"https://vod.lijuyun.cn/sv/447ef52a-18cdd736632/447ef52a-18cdd736632.mp4"}
                                  src={vitem}
                                />
                              </div>
                              <div className='row'>
                                <Dropdown
                                  overlay={
                                    <Menu className={styles['select-over']}>
                                      <Menu.Item onClick={this.onSwitchVideo.bind(this, vindex, index)} key={dataSource.length}>全部视频</Menu.Item>
                                      {
                                        dataSource.map((ditem, dindex) => {
                                          return (
                                            <Menu.Item onClick={this.onSwitchVideo.bind(this, vindex, index)} key={dindex}>{ditem.room}</Menu.Item>
                                          );
                                        })
                                      }
                                    </Menu>
                                  }
                                >
                                  <Button type='primary' className='w90 margin-t5'>切换</Button>
                                </Dropdown>
                                <Popconfirm
                                  title="您确定要删除该视频吗?"
                                  onConfirm={this.delVideo.bind(this, index, vindex)}
                                  okText="确认"
                                  cancelText="取消"
                                >
                                  <Button type='danger' className='w90 margin-t5'>删除视频</Button>
                                </Popconfirm>
                              </div>
                            </div>
                          );
                        })
                      }
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <RemarksModal
          ref={this.remarksModal}
          updateTable={this.updateTable}
        />
        <RelateModal
          ref={this.relateModal}
          updateTable={this.updateRoom}
        />
        <MasterModal
          ref={this.masterModal}
          upload={this.onOk}
        />
        <SizeModal
          ref={this.sizeModal}
          upload={this.updateSize}
        />
        <SpecialModal
          ref={this.specialModal}
          upload={this.updateSize}
        />
        <Modal
          title={modalTitle}
          visible={visibleRoom}
          width={700}
          onCancel={this.onCancelRoom}
          onOk={this.onOkRoom}
          okText='确定'
          cancelText='取消'
        >
          <div>
            <Input className='margin-b10' value={modalValue} onChange={this.onModalValueChange} />
            <div className='row-w'>
              {
                modalTitle === '房间名称' && roomType.map((item, index) => {
                  return (
                    <div key={index} className={styles['room_type_div']} onClick={this.onRoomModalValue.bind(this, item)}>{item}</div>
                  )
                })
              }
              {
                modalTitle === '宽度说明' && widthExplain.map((item, index) => {
                  return (
                    <div key={index} className={styles['room_type_div']} onClick={this.onRoomModalValue.bind(this, item)}>{item}</div>
                  )
                })
              }
              {
                modalTitle === '高度说明' && heightExplain.map((item, index) => {
                  return (
                    <div key={index} className={styles['room_type_div']} onClick={this.onRoomModalValue.bind(this, item)}>{item}</div>
                  )
                })
              }
            </div>
          </div>
        </Modal>

      </Modal>
    );
  }
  getTitle = (workInfo, orderInfo) => {
    return (
      <div className='row-l'>
        <div className='margin-r20'>数据整理2</div>
        <div className='col-t vertical-lt'>
          <div>（师傅：{workInfo.name}，联系电话：{workInfo.phone}）</div>
          <div>（客户：{workInfo.customer},客户电话：{workInfo.customerTel},地址：{workInfo.province + workInfo.city + workInfo.district + workInfo.address}）</div>
          <div>（商户：{orderInfo.shop}，备注：{workInfo.shop_remark}）</div>
        </div>

      </div>
    );
  }
  //插入1个房间
  onInsert = (index) => {
    let dataSource = _.cloneDeep(this.state.dataSource);
    let newRoomData = _.cloneDeep(init);
    dataSource.splice(index, 0, newRoomData);
    dataSource.forEach((item, index) => {
      item.id = index;
    })
    this.setState({
      dataSource: dataSource,
    })
  }
  //更新数据
  updateTable = (data, index) => {
    let dataSource = _.cloneDeep(this.state.dataSource);
    dataSource[index] = data;
    this.setState({
      dataSource: dataSource
    })
  }
  onRemarksModal = (index, data) => {
    this.remarksModal.current.onShowModal(index, data);
  }

  onConfirm = (index) => {
    let dataSource = _.cloneDeep(this.state.dataSource);
    // if (dataSource.length === 1) {
    //   message.warn('至少需要一条数据');
    //   return;
    // }
    dataSource.splice(index, 1);
    this.setState({
      dataSource: dataSource,
    })
  }
  //新增房间
  onAddClick = () => {
    let dataSource = _.cloneDeep(this.state.dataSource);
    let newRoomData = _.cloneDeep(init);
    newRoomData.room = '房间' + (dataSource.length + 1);
    dataSource.push(newRoomData);
    dataSource.forEach((item, index) => {
      item.id = index;
    })
    this.setState({
      dataSource: dataSource,
    })
  }
  // 
  changeSum = (index, prop, e) => {
    let dataSource = _.cloneDeep(this.state.dataSource);
    if (prop === 'power') {
      let prop17 = dataSource[index].prop17.split('|');
      prop17[1] = e.target.value;
      if (e.target.value === '无') {
        prop17[2] = '';
      }
      dataSource[index].prop17 = prop17.join('|');
    } else if (prop === 'powerDir') {
      let prop17 = dataSource[index].prop17.split('|');
      prop17[2] = e.target.value;
      dataSource[index].prop17 = prop17.join('|');
    } else if (['prop15', 'prop14', 'prop12', 'width', 'height'].includes(prop)) {
      dataSource[index][prop] = e.target.value;
      if (prop === 'prop14' && e.target.value === '无') {
        dataSource[index].prop15 = '/';
      }
    } else if (prop === 'prop4') {
      let prop4 = dataSource[index].prop4.split('|');
      prop4[0] = e.target.value;
      dataSource[index].prop4 = prop4.join('|');
    } else if (prop === 'prop3') {
      dataSource[index][prop] = e.target.value;
      if (e.target.value === '无') {
        let prop4 = dataSource[index].prop4.split('|');
        prop4[0] = '';
        dataSource[index].prop4 = prop4.join('|');
      }
    } else if (prop === 'valance') {
      let prop16 = dataSource[index].prop16.split('|');
      prop16[0] = e.target.value;
      if (e.target.value === '无') {
        prop16[1] = '/';
      } else {
        prop16[2] = '无包边';
      }
      dataSource[index].prop16 = prop16.join('|');
    } else if (prop === 'valanceSize') {
      let prop16 = dataSource[index].prop16.split('|');
      prop16[1] = e.target.value;
      dataSource[index].prop16 = prop16.join('|');
    }
    this.setState({
      dataSource: dataSource,
    })
  }

  // 师傅备注：
  onRemarkChange = (e) => {
    this.setState({
      workRemark: e.target.value
    })
  }

  //安装方式
  onSelectType = (index, e) => {
    let dataSource = _.cloneDeep(this.state.dataSource);
    dataSource[index].prop2 = e;
    let prop4 = dataSource[index].prop4.split('|');
    prop4[1] = '';
    prop4[2] = '';
    dataSource[index].prop4 = prop4.join('|');
    dataSource[index].prop13 = '';
    if (e === '已安装') {
      dataSource[index].prop15 = '';
    } else {
      if (['罗马杆', '宜家罗马杆',].includes(dataSource[index].prop1)) {
        dataSource[index].prop13 = '两边装饰头';
        if (e === '侧装') {
          dataSource[index].prop2 = '侧装|否';
        }
      }
    }
    if (sizeWidth2(dataSource[index].prop1, dataSource[index].prop2, dataSource[index].prop7.split('|')[0])[0]) {
      dataSource[index].width_remark = sizeWidth2(dataSource[index].prop1, dataSource[index].prop2, dataSource[index].prop7.split('|')[0])[0];
    } else {
      dataSource[index].width_remark = '自定义';
    }
    if (sizeHeight2(dataSource[index].prop1, dataSource[index].prop2, dataSource[index].prop7.split('|')[0])[0]) {
      dataSource[index].height_remark = sizeHeight2(dataSource[index].prop1, dataSource[index].prop2, dataSource[index].prop7.split('|')[0])[0];
    } else {
      dataSource[index].height_remark = '自定义';
    }
    this.setState({
      dataSource: dataSource,
    });
  }
  //房间名称，宽高说明
  getModal = (index, name, title) => {
    const { dataSource } = this.state;
    let widthExplain = [];
    let heightExplain = [];
    if (title !== '房间名称') {
      widthExplain = sizeWidth2(dataSource[index].prop1, dataSource[index].prop2, dataSource[index].prop7.split('|')[0]);
      heightExplain = sizeHeight2(dataSource[index].prop1, dataSource[index].prop2, dataSource[index].prop7.split('|')[0]);
    }
    this.setState({
      visibleRoom: true,
      modalIndex: index,
      modalValue: name,
      modalTitle: title,
      widthExplain, heightExplain,
    })
  }
  onShowModal = (e) => {
    this.setState({
      visible: true,
      id: e.id,
      orderInfo: e,
    })
    this.getOrderData(e.id);
  }
  //订单数据
  getOrderData = async (id) => {
    // let dataSource = [{ ...newData }];
    let dataSource = [];
    let res = await getOrder2(id);
    if (res.status !== 200) {
      message.error(res.data);
      this.onCancel();
      return;
    }
    dataSource = res.data.serviceDatas;
    dataSource.forEach((item, index) => {
      item.pic = item.pic !== '' ? JSON.parse(item.pic) : [];
      item.vod = item.vod && item.vod.includes('[') && item.vod.includes(']') ? JSON.parse(item.vod) : [];
      if (item.prop13 === '不配平头') {
        item.prop13 = '两边装饰头';
      }
      if (item.prop1 === '磁控百叶') {
        let width = Number(item.width)
        if (typeof width === 'number' && !isNaN(width) && width > 5) {
          item.width = parseFloat(Number((Number(width) / 100).toFixed(3))).toString();
        }
        let height = Number(item.height)
        if (typeof height === 'number' && !isNaN(height) && height > 5) {
          item.height = parseFloat(Number((Number(height) / 100).toFixed(3))).toString();
        }
      }
      // if (item.prop3 === '无') {
      //   if (item.prop1 !== '磁控百叶' && item.prop2 !== '已安装') {
      //     let prop2 = item.prop2.split('|')[0];
      //     if (prop2 === '侧装' && item.prop12) {
      //       item.prop15 = item.prop12;
      //       item.prop12 = '';
      //     }
      //   }
      // }
    })
    this.getAllVideo(dataSource);
    let workInfo = {
      name: res.data.workerName,
      phone: res.data.workerPhone,
      customer: res.data.name,
      customerTel: res.data.phone,
      province: res.data.province,
      city: res.data.city,
      district: res.data.district,
      address: res.data.address,
      shop_remark: res.data.shop_remark
    };
    let remarks = res.data.worker_remark.split('✱');
    let workRemark = remarks[0] ? remarks[0] : '';
    this.setState({
      dataSource: dataSource,
      workInfo: workInfo,
      workRemark: workRemark,
    })
  }
  getAllVideo = async (dataSource) => {
    dataSource.map(async (item, index) => {
      item.vod.map(async (vitem, vindex) => {
        let local = vindex;
        if (vitem.includes('vod.lijuyun')) {
          this.setState({
            dataSource
          })
        } else {
          let res = await getVideoPlay(vitem);
          if (res.status === 200) {
            item.vod[local] = res.data.playURL;
          }
          this.setState({
            dataSource
          })
        }
      })
    })
  }
  onOkData = (type) => {
    if (type === '暂存') {
      this.setState({
        confirmLoading: true
      });
      this.onOk(false, type, false, '', '', '');
    } else {
      this.masterModal.current.showDrawer();
    }
  }
  onOk = async (isSelf, type, isasync, appraise, dataNUm, dataRemark) => {
    this.setState({
      confirmLoading: true
    });
    let dataSource = _.cloneDeep(this.state.dataSource);
    dataSource.forEach((item, index) => {
      item.pic = JSON.stringify(item.pic)
      item.vod = JSON.stringify(item.vod)

      if (!item.prop18 && !item.prop8) {
        item.prop8 = '暂不提供';
      }
      if (item.prop1 !== '磁控百叶') {
        item.prop19 = item.prop19 || item.prop19 === '0' ? item.prop19.toString() : '无';
      } else {
        let width = Number(item.width)
        if (typeof width === 'number' && !isNaN(width)) {
          item.width = parseFloat(Number((Number(width) * 100).toFixed(1))).toString();
        }
        let height = Number(item.height)
        if (typeof height === 'number' && !isNaN(height)) {
          item.height = parseFloat(Number((Number(height) * 100).toFixed(1))).toString();
        }
      }
    })
    let { id, workRemark, allVideos } = this.state;
    let putType = type === '同步' ? '确定' : type;
    let remark = workRemark + '✱' + dataNUm + '✱' + dataRemark;
    // 师傅备注+数量+数据备注
    let data = {
      orderId: id,
      isasync: isasync,
      isSelf: isSelf,
      type: putType,
      // remark: workRemark,✱
      remark: remark,
      appraise: appraise,
      datas: dataSource,
      // worker_remark+飘窗垫+数据备注
    };
    let res = await putDealdata(data);
    if (res.status !== 204) {
      message.error(res.data);
      this.setState({
        confirmLoading: false
      });
      return;
    }
    // this.setState({
    //   confirmLoading: false
    // });
    if (type === '确定' || type === '同步') {
      this.props.updateTable();
    }
    this.onCancel()
  }
  decide = () => {
    let res = confirm('是否确认关闭');
    if (res) {
      this.onCancel();
    }
  }
  onCancel = () => {
    this.setState({
      visible: false,
      confirmLoading: false,
      allPics: [],
      allVideos: [],
      dataSource: [],
    });
    this.closeModal()
  }
  //关闭弹框
  closeModal = async () => {
    let { id, } = this.state;
    let data = {
      orderId: id,
      isasync: false,
      isSelf: false,
      type: '取消',
      remark: '',
      appraise: '',
      datas: [],
    };
    let res = await putDealdata(data);
    if (res.status !== 204) {
      message.error(res.data);
      return;
    }
  }
  //房间名称，宽高说明
  onRoomModalValue = (e) => {
    this.setState({
      modalValue: e
    })
  }
  onModalValueChange = (e) => {
    this.setState({
      modalValue: e.target.value
    })
  }
  onOkRoom = () => {
    let { modalIndex, modalValue, modalTitle } = this.state;
    let dataSource = _.cloneDeep(this.state.dataSource);
    let visibleRoom = false;
    if (modalTitle === '房间名称') {
      // let exitSame = false;
      // dataSource.map((item, index) => {
      //   if (item.room === modalValue && index !== modalIndex) {
      //     exitSame = true;
      //   }
      // });
      // if (exitSame) {
      //   message.warn('存在同名房间');
      //   return;
      // } else {
      dataSource[modalIndex].room = modalValue;
      // }
    } else if (modalTitle === '宽度说明') {
      dataSource[modalIndex].width_remark = modalValue;
    } else if (modalTitle === '高度说明') {
      dataSource[modalIndex].height_remark = modalValue;
    }
    this.setState({
      dataSource: dataSource,
      visibleRoom,
    })
  }
  onCancelRoom = () => {
    this.setState({
      visibleRoom: false,
    });
  }
  //成品尺寸
  changeSize = (index, record) => {
    this.sizeModal.current.onShow(index, record, '修正');
  }
  updateSize = (index, data) => {
    let dataSource = _.cloneDeep(this.state.dataSource);
    dataSource[index] = data;
    this.setState({
      dataSource: dataSource,
    })
  }

  //图片
  preview = (url) => {
    let features = "height=500, width=800, top=100, left=100, toolbar=no, menubar=no,scrollbars=no,resizable=no, location=no, status=no";
    window.open(url, "newW", features);
  }
  upLoad = async (file, fileList) => {
    let allPics = _.cloneDeep(this.state.allPics);
    if (fileList[fileList.length - 1] !== file) {
      return;
    }
    let leng = allPics.length;
    for (let i = 0; i < fileList.length; i++) {
      let name = await ossUpload(fileList[i], null);
      allPics[leng + i] = name;
    }
    this.setState({
      allPics,
    })
  }
  deletePic = (pindex, index) => {
    let dataSource = [...this.state.dataSource];
    dataSource[index].pic.splice(pindex, 1)
    this.setState({
      dataSource
    });
  }
  deletePicAll = (index) => {
    let allPics = [...this.state.allPics];
    allPics.splice(index, 1)
    this.setState({
      allPics
    });
  }
  onSwitchPic = (pindex, index, e) => {
    let dataSource = [...this.state.dataSource];
    let allPics = [...this.state.allPics];
    if (dataSource[e.key]) {
      let newPic = dataSource[index].pic.splice(pindex, 1)[0];
      dataSource[e.key].pic.push(newPic);
    } else {
      let newPic = dataSource[index].pic.splice(pindex, 1)[0];
      allPics.push(newPic);
    }
    this.setState({
      dataSource, allPics
    });
  }
  onSwitchPicAll = (index, e) => {
    let dataSource = [...this.state.dataSource];
    let allPics = [...this.state.allPics];
    let newPic = allPics.splice(index, 1)[0];
    dataSource[e.key].pic.push(newPic);
    this.setState({
      dataSource, allPics
    });
  }

  //打开建议产品关联弹框
  onOpenRelate = (data, index) => {
    this.relateModal.current.onShow(data, index);
  }
  updateRoom = (data, index) => {
    let dataSource = [...this.state.dataSource];
    // if (dataSource[index].prop1 + dataSource[index].prop2 !== data.prop1 + data.prop2) {
    //   data.prop13 = data.prop1 === '罗马杆' ? data.prop2 === '已安装' ? '无吊环' : '两边装饰头' : '';
    // }
    dataSource[index] = data;
    this.setState({
      dataSource,
    })
  }
  //一键整理
  onMeasure = () => {
    let dataSource = [];
    let allPics = [...this.state.allPics];
    allPics.map((item, index) => {
      let newRoomData = _.cloneDeep(init);
      newRoomData.id = -index - 1;
      newRoomData.room = `房间${index + 1}`;
      newRoomData.pic.push(item);
      dataSource.push(newRoomData);
    })
    this.setState({
      dataSource,
      allPics: [],
    });
  }
  backOrder = async () => {
    let { id } = this.state;
    let res = await putBackOrder(id);
    if (res.status === 204) {
      this.props.updateTable();
      this.onCancel()
    }
  }
  //视频
  uploadVideo = async (file, fileList) => {
    if (fileList[fileList.length - 1] !== file) {
      return;
    }
    if (fileList.length > 1) {
      message.warn('只能上传单个视频');
      return;
    }
    let decimal = (new Date()).valueOf();
    let name = `${convert.toString36(decimal)}`.replace(/:/g, '-');
    let res = await getVideoInfo(name, file.name);
    let uploadAddress = JSON.parse(decodeURI(atob(res.data.uploadAddress)));
    let uploadInfos = {
      video: res.data.videoId,
      Endpoint: uploadAddress.Endpoint,
      Bucket: uploadAddress.Bucket,
      object: null,
    };
    let that = this;
    this.uploader = new AliyunUpload.Vod({
      userId: '112',
      region: 'cn-shanghai',
      partSize: 1048576,
      parallel: 5,
      retryCount: 3,
      retryDuration: 2,
      'onUploadstarted': async (uploadInfo) => {
        this.uploader.setUploadAuthAndAddress(uploadInfo, res.data.uploadAuth, res.data.uploadAddress, res.data.videoId);
      },
      'onUploadEnd': async function (uploadInfo) {
        // let rsp = await getVideoSub(res.data.videoId);
        // if (rsp.status === 204) {
        that.getVideoUrl(res.data.videoId);
        // } else {
        // message.error(rsp.data);
        // }
      }
    });
    this.uploader.addFile(file, uploadInfos.Endpoint, uploadInfos.Bucket, null, '{"Vod":{}}');
    this.uploader.startUpload();
  }
  getVideoUrl = async (e) => {
    let res = await getVideoPlay(e);
    if (res.status === 200) {
      let allVideos = _.cloneDeep(this.state.allVideos);
      allVideos.push(res.data.playURL);
      this.setState({
        allVideos
      })
    }
  }
  onSwitchVideo = (vindex, index, e) => {
    let dataSource = [...this.state.dataSource];
    let allVideos = [...this.state.allVideos];
    if (dataSource[e.key]) {
      let newVideo = dataSource[index].vod.splice(vindex, 1)[0];
      dataSource[e.key].vod.push(newVideo);
    } else {
      let newVideo = dataSource[index].vod.splice(vindex, 1)[0];
      allVideos.push(newVideo);
    }
    this.setState({
      dataSource, allVideos
    });
  }
  delVideo = (index, vindex) => {
    let dataSource = _.cloneDeep(this.state.dataSource);
    dataSource[index].vod.splice(vindex, 1);
    this.setState({
      dataSource
    })
  }
  onSwitchVideoAll = (index, e) => {
    let dataSource = [...this.state.dataSource];
    let allVideos = [...this.state.allVideos];
    let newPic = allVideos.splice(index, 1)[0];
    dataSource[e.key].vod.push(newPic);
    this.setState({
      dataSource, allVideos
    });
  }
  delVideoAll = (index) => {
    let allVideos = [...this.state.allVideos];
    allVideos.splice(index, 1)
    this.setState({
      allVideos
    });
  }
  //特殊备注
  showSpecial = (data, index) => {
    this.specialModal.current.onShow(data, index);
  }
  toCopy = (e) => {
    var aux = document.createElement("textarea");
    aux.value = e;
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    message.success('复制成功');
  }
}

export default IndexModal;